<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <el-image
      :src="require('../../assets/images/brand/sucess01.png')"
      fit="fill"
    ></el-image>
    <div class="success_box">
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess06.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年电力、水电行业优秀工程咨询成果奖评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            第三届全国电力工程行业“最美工程师”现场终评
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年度电力工程科学技术进步奖初评会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            第六届电力工程科学技术进步奖终评会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年电力工程设计专有技术
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年度电力、水电行业“四优” 终评会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021年电力工程行业 优秀QC小组活动成果评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021新闻奖复评
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            第四届电力工程行业“最美工程师”现场终评
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            第五批电力勘测设计行业供配电设计专家评选会
          </el-col>
        </el-row>
      </div>
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess03.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2019年度中国能建科学技术奖评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            中国能源建设股份有限公司科学技术委员会2019年第一次会议
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2019年正高级工程师评审
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年度中国能建科学技术奖评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            中国能源建设股份有限公司科学技术委员会2020年第一次会议
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年正高级工程师评审
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年度中国能建工程技术专家评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021年度中国能建科学技术奖评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            中国能源建设股份有限公司科学技术委员会2021年第一次会议
          </el-col>
        </el-row>
      </div>
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess04.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            规划设计集团科技委2019年第一次工作会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            规划设计集团2020年度科技奖评审
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            规划设计集团科技委2020年度第二次工作会议
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            规划设计集团（中电工程）科学技术委员会2021年度第一次工作会议
          </el-col>
        </el-row>
      </div>
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess05.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2019年度中层管理者民主测评
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            公司首席师、资深师岗位任职资格评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            公司专业技术资格评审会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020-2021年度公司技术专家评选
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020年中国能建工程技术专家候选人评选会
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            民主测评及后备干部推荐（2021年2月）
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021年科学技术委员会工作会议
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021年职能调研、管理创新立项
          </el-col>
        </el-row>
      </div>
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess07.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2021年博后科研工作站申报课题评审
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            2020科技进步奖
          </el-col>
        </el-row>
      </div>
      <div class="successItem">
        <div class="successlogo">
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/sucess10.png')"
            fit="fill"
          ></el-image>
        </div>
        <el-row class="succesprojects">
          <el-col class="suitem" :md="{ span: 8, offset: 4 }">
            融媒体技术应用展示发布环节
          </el-col>
          <el-col class="suitem" :md="{ span: 8, offset: 4 }"> </el-col>
        </el-row>
      </div>
    </div>
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  }
}
</script>
<style lang="less">
.successItem {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  font-family: 微软雅黑;
  font-size: 16px;
  color: #5a5a5a;
  margin: 50px auto;
  line-height: 28px;
  width: 100%;
}
.success_box {
  background: url('../../assets/images/brand/sucess08.png') no-repeat;
  display: block;
}
.successlogo {
  flex-shrink: 0;
  padding: 0px 0px 30px 0px;
}
.succesprojects {
  flex-grow: 1;
  flex-shrink: 0;
  width: 100%;
}
.suitem {
  padding: 2px 10px;
}
</style>
